<template>
  <div class="recommendation-wrapper">
    <div class="recommendation-body">
      <div class="complete-bp">
        <div class="complete-bp-wrapper">
          <img class="icon" height="65" width="69" src="/assets/img/lilla-bp-done.svg" loading="lazy" />
          <div class="wording">
            <span
              >Beauty profile telah berhasil dilengkapi dan kamu berhak mendapatkan <strong>150 </strong>
              <img height="15" width="15" src="/assets/img/icon-sp.svg" loading="lazy" />
            </span>
          </div>
          <div class="">
            <button class="btn red" @click="$router.push('/')">Go to homepage</button>
          </div>
        </div>
      </div>
      <template v-if="recommendationProduct.length && isFinishedLoading">
        <div class="separator"></div>
        <div class="recommendation-product">
          <p class="title">Recommendation For You</p>
          <div class="recommendation-product-wrapper">
            <ListProductSlide
              key="recommendationProduct"
              :products="recommendationProduct"
              :is-loading-finish="isFinishedLoading"
              :per-page-custom-props="3"
            />
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
const Config = require('~/config/default.env').default;
// import { startCase } from "lodash";
export default {
  name: 'my-recommendation',
  components: {
    ListProductSlide: () => import('@/components/dashboard/snippet/list-product-slide'),
  },
  beforeRouteEnter(to, from, next) {
    if (from.path !== '/beauty-profile') {
      next({ path: '/' });
      return;
    }
    next();
  },
  data() {
    return {
      recommendationProduct: [],
      isFinishedLoading: false,
    };
  },
  created() {
    this.fetchRecommendationProduct();
  },
  methods: {
    fetchRecommendationProduct() {
      const $filter = {
        $or: [{ is_active_in_review: true }, { is_active_in_sociolla: true }],
      };
      const userProfile = this.$store.getters.userProfile;
      if (userProfile && userProfile.beauty) {
        $filter['tags'] = userProfile.beauty
          .map((b) => {
            return b.subtags.map((subtag) => this.$startCase(subtag.name));
          })
          .flat();
      }
      axios
        .get(Config.MS_SOCO_PUBLIC_API_URL + '/products/sociolla/recommendation', {
          params: {
            filter: $filter,
            limit: 10,
          },
        })
        .then((response) => {
          if (response && response.status === 200 && response.data) {
            this.recommendationProduct = response.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.isFinishedLoading = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.recommendation-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fbf7f8;
  .recommendation-body {
    flex: 1;
    padding-top: 60px;
    width: 819px;
    margin: auto;
    background: white;
    @media (max-width: 1100px) {
      padding: 0;
      width: 100%;
    }
    .complete-bp {
      width: 328px;
      margin: auto;
      text-align: center;
      padding-top: 40px;
      padding-bottom: 40px;
      @media (max-width: 1100px) {
        width: 100%;
        padding-bottom: 24px;
      }
      .complete-bp-wrapper {
        padding: 0 40px;
        .wording {
          margin-top: 25px;
          margin-bottom: 20px;
        }
        button {
          width: 178px;
        }
      }
    }
    .separator {
      height: 8px;
      background: #f6f6f6;
    }
    .recommendation-product {
      padding: 30px;
      &-wrapper {
        width: 659px;
        margin: auto;
      }
      @media (max-width: 1100px) {
        padding: 16px;
        &-wrapper {
          width: 100%;
        }
      }
      .title {
        font-family: 'lato-bold', sans-serif;
        font-size: 12px;
        color: #231f20;
        letter-spacing: 2px;
        line-height: 15px;
        margin-bottom: 30px;
        margin-top: 0;
        text-transform: uppercase;
        @media (max-width: 1100px) {
          margin-bottom: 12px;
        }
      }
    }
  }
}
</style>
